/**
 * LD-1385 pricing page: Growth + Done-for-you + Enterprise.
 *
 * Growth is the existing Business plan (same Stripe product and prices) sold under a new name,
 * so turning this off (REACT_APP_PRICING_V2=false) brings back the Starter/Pro/Business page
 * with no billing data to undo.
 */
export const isPricingV2 = (process.env.REACT_APP_PRICING_V2 ?? 'false').toLowerCase() === 'true'

/** billing_plans entry the Growth card sells. */
export const GROWTH_SOURCE_PLAN_NAME = 'Business'
export const GROWTH_PLAN_NAME = 'Growth'
export const GROWTH_PLAN_DESCRIPTION = 'AI GTM platform. Everything included.'

/** Display only: plan checks, analytics and stored data keep the original name. */
export const getPlanDisplayName = (name?: string) =>
    isPricingV2 && name === GROWTH_SOURCE_PLAN_NAME ? GROWTH_PLAN_NAME : name

export const getPlanDisplayDescription = (name?: string, description?: string) =>
    isPricingV2 && name === GROWTH_SOURCE_PLAN_NAME ? GROWTH_PLAN_DESCRIPTION : description

/**
 * Canceled and trial users on a plan we no longer sell (Starter, Pro, legacy prices; trials start on
 * Pro monthly) can only buy Growth from the pricing page, not that plan through seats or cycle changes.
 */
export const canOnlyBuyGrowth = (subscription?: { status?: string }, trial?: boolean, planName?: string) =>
    isPricingV2 && (subscription?.status === 'canceled' || !!trial) && planName !== GROWTH_SOURCE_PLAN_NAME
